<template>
  <!--<transition mode="out-in"-->
              <!--enter-active-class="animated zoomInUp"-->
              <!--leave-active-class="animated zoomOutDown">-->
    <div style="width: 100%;">

      <!--主图-->
      <div class="mainImg">
        <img src="../assets/contactUs.jpg" alt="动态新闻">
      </div>

      <!--走进我们标题-->
      <div class="showTitle">
        <p class="showP1" style="margin-top: 100px;">走进我们</p>
      </div>

      <!--走进我们：详情-->
      <div class="walk-into-us">
        <p class="info" style="text-indent: 2em;">
          武汉网明无障碍科技有限公司是一家社会创新型的企业，主要由华中科技大学的硕士组成，一直专注于无障碍领域
          产品的研究，致力于打破“数字鸿沟”，具有丰富的研究技术成果。目前重心在启明导盲系列产品的研发、生产和销售，
          已经初步搭建了一套盲人生活、娱乐、学习、交流、沟通、出行的系统级产品。公司的宗旨是做最高效、最有性价比的导盲系统，
          以适中的价格为盲人群体提供高端服务，启明系列产品于软件、硬件、互联网服务三种形式逐层深入解决盲人获取信息和
          日常出行的问题，致力于为盲人开启一个新的“视”界，让盲人像明眼人一样平等快捷方便的使用智能手机和无障碍的出行。
          公司团队和产品曾多次被人民日报、CCTV等多家媒体报道，近几年共获得国内外技术比赛等20多项大奖。
        </p>

        <Row>
          <Col :xs="24" :sm="24" :md="12" :lg="12" class="theory">
          <ul style="list-style: none;text-align: left;margin-left:20%;margin-top: 50px;">
            <li style="font-size: 2.3rem;font-weight: bold;color:rgba(13, 117, 116, 1)">公司理念</li>
            <li style="font-size: 1.8rem;color:rgb(13,117,116)">用科技点亮盲人新视界</li>
            <li style="font-size: 2.3rem;font-weight: bold;color:rgba(13, 117, 116, 1);margin-top:50px;">公司理念</li>
            <li style="font-size: 1.8rem;color:rgb(13,117,116)">科技   创新  融合</li>
          </ul>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="12">
          <img src="../assets/theory.jpg"
               alt="公司发展1"
               style="width: 100%;height: 400px;"
               height="379px">
          </Col>
        </Row>

      </div>

      <!--公司发展标题：class延用走进我们标题-->
      <div class="showTitle">
        <p class="showP1" style="margin-top: 100px;">公司发展</p>
      </div>

      <!--公司发展详情-->
      <div class="develop-detail">
        <!--图文-->
        <ul style="text-align: center;margin-top: 30px;">
          <li class="developItem">武汉网明科技公司成立于2018年，专注于用科技点亮盲人"新视界"</li>
          <li class="developItem">迄今为止，公司依托自主研发的启明OS操作系统，开发出了启明瞳，启明FM,启明出行等助力盲人的多款App</li>
          <li class="developItem">凭借着专为盲人打造的操作辅助系统，强大的人工智能技术与广大的志愿者帮助</li>
          <li class="developItem">网明科技成功的改变了数千盲人的生活</li>
        </ul>
        <Row style="width: 90%;margin: 0 auto;">
          <img src="../assets/develop.jpg" alt="" width="90%">
        </Row>
        <!--地图-->
        <!--<Row style="width: 90%;margin: 2% auto;">
          &lt;!&ndash;<Col :xs="24" :sm="24" :md="16" :lg="16">
          <div class="map" id="map">
            &lt;!&ndash;导入百度地图&ndash;&gt;
          </div>
          </Col>&ndash;&gt;
          <Col :xs="24" :sm="24" :md="8" :lg="8">
          <div style="background-color:rgba(57, 207, 200, 1)" class="map">
            <p class="contact" style="font-size: 1.5rem;padding-top: 90px">关注我们</p>
            <p class="contact" style="font-size: 1.2rem;">助力视力障碍人群</p>
          </div>
          </Col>
        </Row>
        <Row style="width: 90%;margin: 2% auto;">
          <Col :xs="24" :sm="24" :md="8" :lg="8">
            <div style="background-color:rgba(57, 207, 200, 1)" class="map">
              <p class="contact" style="font-size: 1.5rem;padding-top: 100px">联系我们</p>
            </div>
          </Col>
        </Row>-->
      </div>

      <div class="with-us">
        <span>关注我们 助力视力障碍人群</span><br><br><br>
        <div class="v-code">
          <div class="v-code-content">
            <img src="../assets/v-code-qmt.png" alt="二维码" style="width: 150px; height: 150px">
            <p style="font-size: 22px">微信扫一扫关注启明瞳</p>
          </div>
          <div class="v-code-content">
            <img src="../assets/v-code-help.png" alt="二维码" style="width: 150px; height: 150px">
            <p style="font-size: 22px">微信扫一扫关注我能帮帮忙</p>
          </div>
          <div class="v-code-content">
            <img src="../assets/v-code-wza.png" alt="二维码" style="width: 150px; height: 150px">
            <p style="font-size: 22px">微信扫一扫关注无障碍科技</p>
          </div>
        </div>
      </div>

      <div class="with-us">
        <span>联系我们 </span>
        <br><br><br>
        <div style="display: inline-block; text-align: center; float: left; padding-left: 14%">
          <p style="font-size: 22px">
            官方QQ群：
            <a target="_blank" title="点击加入无障碍科技官方群" aria-label="点击加入无障碍科技官方群"
               href="//shang.qq.com/wpa/qunwpa?idkey=d127d227a20c53be0e4f2c0b62cc7a1656b0ec34dbbcebfe1ba6124db7e21aa2">
            704750180</a>
          </p>
        </div>
        <div style="display: inline-block; text-align: center; float: left; padding-left: 14%">
          <p style="font-size: 22px">官方邮箱：<a href="mailto:feedback@accessible.org.cn" title="发送邮件" aria-label="发送邮件">feedback@accessible.org.cn</a></p>
        </div>
        <br><br><br>
        <div style="display: inline-block; text-align: center; float: left; padding-left: 14%">
          <p style="font-size: 22px">吐槽反馈：
            <a style="font-size: 22px; margin-bottom: 7px"
               target="_blank" title="点击吐槽"
               aria-label="点击吐槽" href="https://support.qq.com/products/30778?">
            点击吐槽</a></p>
        </div>
        <br><br><br>
      </div>

      <!--页脚-->
      <div class="footer">
        <ul style="display: flex;align-items: center;flex-direction: column;list-style: none;justify-content: center; height: 100%">
          <li class="info">Copyright © 2017-2020 All rights reserved 版权所有 © 无障碍科技有限公司</li>
          <li class="info">备案号：鄂ICP备18005954号</li>
        </ul>
      </div>

    </div>
  <!--</transition>-->
</template>

<script>
  export default {
    name: "contactUs",
    activated(){
      //创建地图实例
      var map = new BMap.Map('map');
      //创建一个坐标
      var point =new BMap.Point(114.4306199,30.50962730);
      //地图初始化，设置中心点坐标和地图级别
      map.centerAndZoom(point,15);
      var marker = new BMap.Marker(point); 　　　　　 // 创建标注
      map.addOverlay(marker);      // 将标注添加到地图中
      var infoWindow = new BMap.InfoWindow("We are here"); // 创建信息窗口对象
      map.openInfoWindow(infoWindow,point);     //开启信息窗口
      map.enableScrollWheelZoom();
    }
  }
</script>

<style scoped>
  .mainImg img {
    width: 100%;
    height: 600px;
  }  /*主图*/
  .showTitle{
    margin:1% auto;
    width: 100%;
    text-align: center;
  }/*走进我们标题*/
  .showTitle .showP1{
    font-size:2.1rem;
    color:rgba(13, 117, 116, 1);
    font-weight: bold;
  }
  .showTitle .showP2 {
    font-size: 1.2rem;
    color:rgba(13, 117, 116, 1);
    font-family: Microsoft YaHei;
  }
  .showTitle .showHr {
    width: 8rem;
    border-bottom:1px solid rgba(13, 117, 116, 1);
    border-top:none;
    margin: 0 auto;
  }
  .theory{
    background-color:rgba(13, 117, 116, 0.1);
    height: 400px;
  }
  .developItem{
    color:rgba(13, 117, 116, 1);
    line-height: 1.8rem;
    font-size: 1.0rem;
  }
  .walk-into-us{
    margin: 1% auto;
    text-align: center;
    width: 100%;
  }/*走进我们详情文字整体*/
  .walk-into-us .info{
    text-align: justify;
    color:rgba(13, 117, 116, 1);
    font-size:1rem;
    width: 90%;
    margin: 1% auto;
  }/*走进我们详情文字*/
  .walk-into-us hr{
    border-bottom: 1px solid #ccc;
    border-top:none;
    margin: 0 auto;
    width: 90%;
  }/*走进我们详情文字的上下横线*/
  .develop-detail{
    margin:1% auto;
    text-align: center;
  }/*公司发展*/
  .develop-detail .bg{
    width:100%;
    height:129px;
    margin-top:-5px;
    background-color:rgba(0, 186, 173, 1);
  }/*公司发展文字背景*/
  .develop-detail p{
    color:#fff;
    text-align: justify;
    text-indent: 2em;
    margin: 0 auto;
    font-size: 0.8rem;
    padding: 2%
  }/*公司发展文字介绍*/
  .develop-detail .map{
    height: 250px;
    width: 250px;
  }
  .develop-detail .contact{
    color:#fff;
    text-align: center;
    padding-right: 50px;
  }/*右边文字*/
  .with-us{
    width: 100%;
    padding-top: 50px;
    display: inline-block;
  }
  .with-us span{
    font-size: 40px;
    font-weight: bolder;
    margin-left: 10%;
  }
  .with-us .v-code{
    width: 100%;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  .v-code .v-code-content{
    width: 150px;
    text-align: center;
  }

  .footer{
    background-color: rgba(57, 207, 204, 1);
    text-align: center;
    width: 100%;
    height: 130px;
  }/*页脚*/
  .footer .info{
    color:#fff;
    font-size:0.8rem;
  }/*页脚：里面的内容*/

  /*手机竖屏*/
  @media only screen
  and (min-width: 320px)
  and (max-width: 767px)
  and (orientation: portrait){
    .mainImg img{
      height: 200px;
      margin-top:1%;
    }
    .develop-detail .bg{
      height: 180px;
    }
    .with-us{
      text-align: center;
    }
    .with-us span{
      margin-left: 0;
    }
    .with-us .v-code-content{
      width: 100%;
    }
  }

  /*手机横屏*/
  @media only screen
  and (min-width: 320px)
  and (max-width: 767px)
  and (orientation: landscape){
    .mainImg img{
      height: 300px;
      margin-top:1%;
    }
    .develop-detail p{
      font-size: 0.7rem;
    }/*公司发展文字介绍*/
  }

  /*平板竖屏*/
  @media only screen
  and (min-width: 768px)
  and (max-width: 1024px)
  and (orientation: portrait){
    .mainImg img{
      height: 400px;
      margin-top:2%;
    }
  }

  /*平板横屏*/
  @media only screen
  and (min-width: 768px)
  and (max-width: 1024px)
  and (orientation: landscape){
    .mainImg img{
      height: 400px;
      margin-top:2%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/contactUs.vue